import {config} from "@/config/config";

export default [
  {
    path: "/",
    name: "MapPage",
    component: () => import("@/pages/MapPage.vue"),
    meta: {
      breadcrumb: [{label: "Map"}],
      requireLogin: true,
      layout: 'App',
      module: 'layer'
    },
  },

  {
    path: "/profile/",
    name: "ProfilePage",
    component: () => import("@/modules/syncmap/pages/user/Profile.vue"),
    meta: {
      breadcrumb: [{label: "Profile"}],
      requireLogin: true,
      layout: 'App',
      module: 'MobileProfile',
      requiredRight: 'view'
    }
  },

  {
    path: "/login/",
    name: "Login",
    component: () => import("@/modules/syncmap/pages/user/Login.vue"),
    meta: {
      breadcrumb: [{label: "Login"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/create-account/",
    name: "Register",
    component: () => import("@/modules/syncmap/pages/user/Register.vue"),
    meta: {
      breadcrumb: [{label: "Create account"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/recover-password/",
    name: "RecoverPassword",
    component: () => import("@/modules/syncmap/pages/user/RecoverPassword.vue"),
    meta: {
      breadcrumb: [{label: "Recover password"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/reset-password/",
    name: "ResetPassword",
    component: () => import("@/modules/syncmap/pages/user/ResetPassword.vue"),
    meta: {
      breadcrumb: [{label: "Reset password"}],
      requireLogin: false,
      layout: 'Unauthorized'
    },
  },

  {
    path: "/embed/",
    name: "Embed",
    component: () => import("@/pages/EmbedPage.vue"),
    meta: {
      requireLogin: false,
      layout: 'App',
      module: 'layer',
      requiredRight: 'view'
    },
  },

  {
    path: "/page/:formId/:slug?",
    name: "FormRender",
    component: () => import("@/pages/documents/FormRenderPage.vue"),
    meta: {
      breadcrumb: [{label: "Form Page"}],
      requireLogin: true,
      layout: 'App'
    }
  },

  {
    path: "/dashboard/:moduleCode",
    name: "ModuleDashboard",
    component: () => import("@/pages/ModuleDashboardPage.vue"),
    meta: {
      breadcrumb: [{label: "Module Dashboard Page"}],
      requireLogin: true,
      layout: 'App'
    }
  },

  {
    path: "/my-institutions/",
    name: "MyInstitutions",
    component: () => import("@/modules/syncmap/pages/user/Institutions.vue"),
    meta: {
      breadcrumb: [{label: "My Institutions"}],
      requireLogin: true,
      layout: 'App',
      module: 'mobileOrganizations',
    }
  },
  {
    path: "/report-viewer/:reportId?",
    name: "Report Viewer",
    component: () => import('@/pages/report/ReportViewer.vue'),
    meta: {
      breadcrumb: [{label: 'Report Viewer'}],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view'
    }
  },
  {
    path: "/report-pdf/:reportId?",
    name: "Report PDF",
    component: () => import('@/pages/report/ReportPDF.vue'),
    meta: {
      breadcrumb: [{label: 'Report PDF'}],
      requireLogin: true,
      layout: 'App',
      requiredRight: 'view'
    }
  },
  {
    path: "/app-settings/",
    name: "AppSettingsPage",
    component: () => import("@/modules/syncmap/pages/AppSettingsPage.vue"),
    meta: {
      breadcrumb: [{label: "Settings"}],
      requireLogin: false,
      layout: 'App',
    }
  },
  {
    path: "/notifications/",
    name: "NotificationsPage",
    component: () => import("@/modules/syncmap/pages/NotificationsPage.vue"),
    meta: {
      breadcrumb: [{label: "Notifications"}],
      requireLogin: true,
      layout: 'App',
    }
  },
  {
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/layout/NotFound.vue"),
    meta: {
      requireLogin: false,
      layout: 'NotFound'
    },
  },

]
